// extracted by mini-css-extract-plugin
export default {"skeleton":"DMhRI4","card":"peI8B8","image-wrapper":"iXenb9","image":"xOpv52","titleContainer":"sB6zhZ","title":"o8nGp1","meta":"WeJiUh"};